import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import DocumentMeta from "react-document-meta";
import StyleEditor from "react-style-editor";

import { cuesApi } from "../imports";
import { cueDesign } from "./Cue";
import Layout from "../Layout";
import { H2RButton } from "../imports";
import { H2RInput } from "../imports";
import { H2RSelect } from "../imports";
import { H2RHeading } from "../imports";
import {
	widthAndHeightScreenOptions,
	fontSizeOptions,
	leadingOptions,
	paddingOptions,
	marginOptions,
	transitionOptions,
	transitionDurationOptions,
	roundedOptions,
	borderOptions,
	borderSizeOptions,
	thicknessOptions,
	gradientOptions,
} from "../imports";
import { H2RCheckbox } from "../imports";
import { socketActions } from "../imports";
import { linearGradient, glow } from "./helpers/theme";
import transparentImage from "./img/transparent.jpg";
import ThemeSelectorDropdown from "./ThemeSelectorDropdown";
import GlobalStyles from "./theme/GlobalStyles";
import ThemeSection from "./theme/ThemeSection";
import { findThemeLabel } from "./theme/findThemeLabel";
import ThemePreview from "./theme/ThemePreview";
import { faCheck, faClock, faClose, faDownload, faPlus } from "@fortawesome/free-solid-svg-icons";

export default function ThemeInternals({ cloud = false }) {
	const [newThemeName, setNewThemeName] = useState("");
	const [addingNewTheme, setAddingNewTheme] = useState(false);
	const [cssEditor, setCssEditor] = useState("editor");

	let { projectId, themeId } = useParams();
	let history = useHistory();

	const themeEditorRef = useRef();

	const outputBackgroundColour = useSelector(
		(state) => state.main?.settings?.output_background_colour
	);
	const selectedProject = useSelector(
		(state) => state?.main?.settings?.selectedProject
	);
	const projectDefaultTheme = useSelector(
		(state) => state.main?.projects?.[selectedProject]?.theme
	);
	const themes =
		useSelector((state) => state.main?.projects?.[projectId].themes) || [];
	const baseTheme = useSelector(
		(state) => state.main?.projects?.[projectId].themes?.[themeId]
	);
	const meta = {
		title: `Theme editor - ${baseTheme?.name}`,
	};

	const handleCancelNewTheme = () => {
		setAddingNewTheme(false);
		setNewThemeName("");
	};

	const handleAddNewTheme = async () => {
		const newThemeId = await cuesApi
			.duplicateTheme(selectedProject, themeId, newThemeName)
			.then((res) => {
				if (res.data.newNameEncoded) {
					history.push(`/theme/${projectId}/${res.data.newNameEncoded}`);
				}
				console.log("res", res);
			});
		console.log("newThemeId", newThemeId);
		return handleCancelNewTheme();
	};

	const defaultCss = `
	/*Large and Small text selectors*/
	.${themeId}_large_text {/*color:red!important;*/}
	.${themeId}_small_text {/*color:red!important;*/}

	/*Lower Third specific selectors*/
	.${themeId}_lower_third {/*background:red!important;*/}
	.${themeId}_lower_third_large_text {/*background:red!important;*/}
	.${themeId}_lower_third_small_text {/*background:red!important;*/}

	/*Message specific selectors*/
	.${themeId}_message {/*background:red!important;*/}
	.${themeId}_message_large_text {/*background:red!important;*/}

	/*Time specific selectors*/
	.${themeId}_time {/*background:red!important;*/}
	.${themeId}_time_large_text {/*background:red!important;*/}
	.${themeId}_time_small_text {/*background:red!important;*/}

	/*Ticker specific selectors*/
	.${themeId}_ticker {/*background:red!important;*/}
	.${themeId}_ticker_large_text {/*background:red!important;*/}
	.${themeId}_ticker_small_text {/*background:red!important;*/}

	/*Social specific selectors*/
	.${themeId}_social {/*background:red!important;*/}
	.${themeId}_social_large_text {/*background:red!important;*/}
	.${themeId}_social_small_text {/*background:red!important;*/}
	.${themeId}_social_profile_image {/*border:.5vw solid white;filter: contrast(100%)!important;*/}

	/*Score specific selectors*/
	.${themeId}_score {/*background:red!important;*/}
	.${themeId}_score_large_text {/*background:red!important;*/}
	.${themeId}_score_small_text {/*background:red!important;*/}
	.${themeId}_score_level {/*background:red!important;*/}

	/*Credits specific selectors*/
	.${themeId}_credits {/*background:red!important;*/}
	.${themeId}_credits_large_text {/*background:red!important;*/}
	.${themeId}_credits_small_text {/*background:red!important;*/}

	/*Lower Third Animated specific selectors*/
	.${themeId}_lower_third_animated {/*background:red!important;*/}
	.${themeId}_lower_third_animated_large_text {/*background:red!important;*/}
	.${themeId}_lower_third_animated_small_text {/*background:red!important;*/}

	/*Big Time specific selectors*/
	.${themeId}_big_time {/*background:red!important;*/}
	.${themeId}_big_time_large_text {/*background:red!important;*/}


`;

	useEffect(() => {
		Object.entries(themes).map(([id, theme]) => {
			let refName = `theme_${id}_ref`;

			if (document.getElementsByClassName(refName)[0] === undefined) {
				const style = document.createElement("style");

				style.className = refName;
				style.textContent = theme.overrides?.css;
				document.head.append(style);
			} else {
				const style = document.getElementsByClassName(refName)[0];

				style.textContent = theme.overrides?.css;
			}
		});
	}, [themes]);

	if (baseTheme === undefined) {
		return null;
	} else {
		return (
			<DocumentMeta {...meta}>
				<Layout>
					{/* <section
						className={`overflow-y-auto mx-5 my-5 flex flex-col w-full space-y-4`}
					>
						<Output width="100" height="100" />
					</section> */}
					<div className="flex flex-col px-5 py-5 sm:flex-row w-full sm:w-full overflow-auto">
						<section
							className={`px-2 hidden sm:flex flex-col w-full space-y-4 `}
						>
							<H2RHeading type="h5">Theme preview</H2RHeading>
							{/* <ThemePreview
								outputBackgroundColour={outputBackgroundColour}
								baseTheme={baseTheme}
							/> */}
							<iframe
								title="Theme preview"
								src={`/theme/${projectId}/${themeId}/preview`}
								className="aspect-video overflow-hidden"
							/>
						</section>
						<section
							ref={themeEditorRef}
							className={`sm:overflow-y-auto px-2 py-1 flex flex-col w-full space-y-4`}
						>
							{/* <H2RHeading type="h4">{baseTheme?.name}</H2RHeading> */}
							<div className="flex justify-between">
								<H2RHeading type="h5">Theme</H2RHeading>
								<div className="flex space-x-2">
									<H2RButton
										text="Import"
										size="small"
										type="link"
										colour="dark"
										onClick={() => socketActions.importTheme(projectId)}
									/>
									<H2RButton
										text="New"
										icon={faPlus}
										size="small"
										colour="dark"
										onClick={() => setAddingNewTheme(!addingNewTheme)}
									/>
								</div>
							</div>
							<div className="flex space-x-2">
								<ThemeSelectorDropdown
									themes={themes}
									selectedTheme={baseTheme}
									projectDefaultTheme={projectDefaultTheme}
									onChange={(change) => {
										// cuesApi.changeTheme(selectedProject, change);
										history.push(`/theme/${projectId}/${change}`);
									}}
								/>
								<H2RButton
									text={
										projectDefaultTheme === themeId ? "Default" : "Make default"
									}
									icon={projectDefaultTheme === themeId ? faCheck : ""}
									size="small"
									disabled={projectDefaultTheme === themeId ? true : false}
									colour="dark"
									css="whitespace-pre"
									onClick={() => cuesApi.changeTheme(selectedProject, themeId)}
								/>
							</div>

							{addingNewTheme && (
								<>
									<H2RInput
										label="Theme name"
										value={newThemeName}
										placeholder="My new theme"
										onChange={(text) => setNewThemeName(text)}
									/>
									<div className="flex justify-between">
										<H2RButton
											text="Add new theme"
											size="small"
											colour="main"
											onClick={handleAddNewTheme}
											disabled={!newThemeName}
										/>
										<H2RButton
											text="Cancel"
											size="small"
											type="link"
											colour="light"
											onClick={handleCancelNewTheme}
										/>
									</div>
								</>
							)}
							<GlobalStyles
								baseTheme={baseTheme}
								themeId={themeId}
								onUpdate={(section, element, change) => {
									cuesApi.updateTheme(
										projectId,
										themeId,
										section,
										element,
										change
									);
								}}
							/>

							<H2RHeading type="h5">Graphics</H2RHeading>
							<ThemeSection name="Lower Third" icon={cueDesign("lower_third")}>
								<LowerThirdLayouts
									key={`${baseTheme.name}_lower_third_width`}
									themeId={themeId}
									baseTheme={baseTheme}
									graphic="lower_third"
								/>
							</ThemeSection>
							<ThemeSection name="Lower Third Animated" icon={cueDesign("lower_third_animated")}>
								<LowerThirdAnimatedLayouts
									key={`${baseTheme.name}_lower_third_animated_settings`}
									themeId={themeId}
									baseTheme={baseTheme}
									graphic="lower_third_animated"
								/>
							</ThemeSection>
							<ThemeSection name="Credits" icon={cueDesign("credits")}>
								<CreditsLayouts
									key={`${baseTheme.name}_credits_settings`}
									themeId={themeId}
									baseTheme={baseTheme}
									graphic="credits"
								/>
							</ThemeSection>
							<ThemeSection name="Social" icon={cueDesign("social")}>
								<SocialLayouts
									key={`${baseTheme.name}_social_direction`}
									themeId={themeId}
									baseTheme={baseTheme}
									graphic="social"
								/>
							</ThemeSection>
							<ThemeSection name="Score" icon={cueDesign("score")}>
								<ScoreLayouts
									key={`${baseTheme.name}_score_direction`}
									themeId={themeId}
									baseTheme={baseTheme}
									graphic="score"
								/>
							</ThemeSection>
							<ThemeSection name="Big timer" icon={cueDesign("big_time")}>
								<BigTimeOptions
									key={`${baseTheme.name}_big_time_elapsed`}
									themeId={themeId}
									baseTheme={baseTheme}
									graphic="big_time"
								/>
							</ThemeSection>
							<ThemeSection name="Checklist" icon={cueDesign("checklist")}>
								<ChecklistOptions
									key={`${baseTheme.name}_checklist_options`}
									themeId={themeId}
									baseTheme={baseTheme}
									graphic="checklist"
								/>
							</ThemeSection>
							{/*		<ThemeSection name="Message" icon={cueDesign("message")}>
								<ThemeOverrides
									overrides={baseTheme.overrides}
									graphic="message"
								/>
							</ThemeSection>
							<ThemeSection name="Time" icon={cueDesign("time")}>
							<ThemeOverrides overrides={baseTheme.overrides} graphic="time" />
						</ThemeSection>
						<ThemeSection name="Ticker" icon={cueDesign("ticker")}>
							<ThemeOverrides
								overrides={baseTheme.overrides}
								graphic="ticker"
							/>
						</ThemeSection> */}
							{/* <ThemeSection name="Image" icon={cueDesign("image")}>
							<ThemeOverrides overrides={baseTheme.overrides} graphic="image" />
						</ThemeSection> */}
							<span className="border-b border-gray-700"></span>
							<ThemeSection name="CSS" icon="css">
								<div className="pt-3 mb-10 space-y-4">
									<div className="flex items-center w-100 justify-center space-x-4">
										<H2RButton
											text="CSS Editor"
											colour={cssEditor === "editor" ? "main" : "dark"}
											size="small"
											onClick={() => setCssEditor("editor")}
										/>
										<H2RButton
											text="Text input"
											colour={cssEditor === "text" ? "main" : "dark"}
											size="small"
											onClick={() => setCssEditor("text")}
										/>
									</div>
									{cssEditor === "editor" && (
										<StyleEditor
											key={themeId}
											onChange={(change) => {
												cuesApi.updateTheme(
													projectId,
													themeId,
													"overrides",
													"css",
													change
												);
											}}
											value={
												baseTheme?.overrides?.css === null
													? defaultCss
													: baseTheme?.overrides?.css
											}
											className="bg-gray-800 rounded select-auto"
											defaultValue={defaultCss}
										/>
									)}
									{cssEditor === "text" && (
										<CSSTextEditor
											defaultCss={defaultCss}
											baseTheme={baseTheme}
											themeId={themeId}
										/>
									)}
									<H2RButton
										text="Reset CSS to default"
										colour="dark"
										size="small"
										onClick={() => {
											cuesApi.updateTheme(
												projectId,
												themeId,
												"overrides",
												"css",
												defaultCss
											);
										}}
									/>
									<span className="text-xs text-gray-500">
										Warning: All edits will be lost.
									</span>
								</div>
							</ThemeSection>
							<ThemeSection name="Options" icon="options">
								<H2RInput
									key={themeId}
									label="Theme name"
									colour="dark"
									value={baseTheme.name}
									onChange={(change) => {
										cuesApi.renameTheme(projectId, themeId, change);
									}}
								/>
								<div className="flex  items-center space-x-2">
									<H2RButton
										text={"Export"}
										size="small"
										icon={faDownload}
										colour="dark"
										css="w-min"
										onClick={() => {
											return socketActions.settingsAction("export_theme", {
												projectId,
												themeId,
											});
										}}
									/>
									<H2RButton
										text="Delete"
										icon={faClose}
										colour="dark"
										disabled={
											themeId === "h2r_base_theme" ||
											projectDefaultTheme === themeId
										}
										css="bg-red-500 hover:bg-red-600 w-min"
										size="small"
										onClick={() => {
											cuesApi.deleteTheme(projectId, themeId);
											themeEditorRef.current.scrollTo(0, 0);
											history.push(`/theme/${projectId}/h2r_base_theme`);
										}}
									/>
									<span className="text-xs text-gray-500">
										{themeId === "h2r_base_theme"
											? "Cannot delete base theme."
											: projectDefaultTheme === themeId
											? "Cannot delete default theme."
											: "Warning: This cannot be undone."}
									</span>
								</div>
							</ThemeSection>
						</section>
					</div>
				</Layout>
			</DocumentMeta>
		);
	}
}

const CSSTextEditor = ({ defaultCss, baseTheme, themeId }) => {
	const { projectId } = useParams();
	const [val, setVal] = useState(
		baseTheme.overrides?.css === null ? defaultCss : baseTheme.overrides?.css
	);
	return (
		<textarea
			className="bg-gray-900 w-full focus:outline-none focus:ring rounded"
			defaultValue={
				baseTheme.overrides?.css === null
					? defaultCss
					: baseTheme.overrides?.css
			}
			// value={
			// 	baseTheme.overrides?.css === null
			// 		? defaultCss
			// 		: baseTheme.overrides?.css
			// }
			rows={10}
			onChange={(e) => {
				console.log(e.target.value);
				cuesApi.updateTheme(
					projectId,
					themeId,
					"overrides",
					"css",
					e.target.value
				);
			}}
		/>
	);
};

const LowerThirdLayouts = ({ themeId, baseTheme, graphic }) => {
	let { projectId } = useParams();
	return (
		<H2RSelect
			label="Width"
			selected={baseTheme[graphic]?.width || "auto"}
			colour="dark"
			onChange={(change) => {
				cuesApi.updateThemeOverride(
					projectId,
					themeId,
					"lower_third",
					"width",
					change
				);
			}}
			options={[
				{
					label: "Auto",
					value: "auto",
				},
				{
					label: "Full",
					value: "full",
				},
			]}
		/>
	);
};

const LowerThirdAnimatedLayouts = ({ themeId, baseTheme, graphic }) => {
	let { projectId } = useParams();
	return (
		<H2RCheckbox
		key={`${baseTheme.name}_opacity`}
		randomId={`second_line_opacity`}
		label="Second line"
		checkboxLabel="Darken second line"
		checked={baseTheme[graphic]?.["second_line_opacity"] === true ? true : false}
		onChange={(change) => {
			cuesApi.updateThemeOverride(
				projectId,
				themeId,
				"lower_third_animated",
				"second_line_opacity",
				change
			);
		}}
	/>
	);
};

const CreditsLayouts = ({ themeId, baseTheme, graphic }) => {
	let { projectId } = useParams();
	return (
		<H2RSelect
				label="Crowd size"
				colour="dark"
				selected={baseTheme[graphic]?.crowd_size || "20"}
				onChange={(change) => {
					cuesApi.updateThemeOverride(
						projectId,
						themeId,
						"credits",
						"crowd_size",
						change
					);
				}}
				options={[
					{
						label: "Small",
						value: "20",
					},
					{
						label: "Medium",
						value: "15",
					},
					{
						label: "Large",
						value: "10",
					},
				]}
			/>
	);
};

const SocialLayouts = ({ themeId, baseTheme, graphic }) => {
	let { projectId } = useParams();
	return (
		<>
			<H2RSelect
				label="Image shape"
				colour="dark"
				selected={baseTheme[graphic]?.image_shape || "circle"}
				onChange={(change) => {
					cuesApi.updateThemeOverride(
						projectId,
						themeId,
						"social",
						"image_shape",
						change
					);
				}}
				options={[
					{
						label: "Circle",
						value: "circle",
					},
					{
						label: "Square",
						value: "square",
					},
					{
						label: "Rounded",
						value: "rounded",
					},
				]}
			/>
		</>
	);
};

const ScoreLayouts = ({ themeId, baseTheme, graphic }) => {
	let { projectId } = useParams();
	return (
		<>
			<H2RSelect
				label="Layout"
				colour="dark"
				selected={baseTheme[graphic]?.direction || "side_by_side"}
				onChange={(change) => {
					cuesApi.updateThemeOverride(
						projectId,
						themeId,
						"score",
						"direction",
						change
					);
				}}
				options={[
					{
						label: "Side by side",
						value: "side_by_side",
					},
					{
						label: "Stacked",
						value: "stacked",
					},
				]}
			/>
			<H2RCheckbox
				key={`${baseTheme.name}_odd_opacity`}
				randomId={`odd_opacity`}
				checkboxLabel="Lower opacity of odd levels"
				checked={baseTheme[graphic]?.["odd_opacity"] === false ? false : true}
				onChange={(change) => {
					cuesApi.updateThemeOverride(
						projectId,
						themeId,
						"score",
						"odd_opacity",
						change
					);
				}}
			/>
		</>
	);
};

const BigTimeOptions = ({ themeId, baseTheme, graphic }) => {
	let { projectId } = useParams();
	return (
		<>
			<H2RSelect
				label="Elapsed time animation style"
				colour="dark"
				selected={baseTheme[graphic]?.elapsedStyle || "duration"}
				onChange={(change) => {
					cuesApi.updateThemeOverride(
						projectId,
						themeId,
						"big_time",
						"elapsedStyle",
						change
					);
				}}
				options={[
					{
						label: "Animate based on total duration",
						value: "duration",
					},
					{
						label: "Animate every second",
						value: "seconds",
					},
				]}
			/>

			<H2RSelect
				label="Edges"
				colour="dark"
				selected={baseTheme[graphic]?.roundedStyle || "rounded"}
				onChange={(change) => {
					cuesApi.updateThemeOverride(
						projectId,
						themeId,
						"big_time",
						"roundedStyle",
						change
					);
				}}
				options={[
					{
						label: "Rounded",
						value: "rounded",
					},
					{
						label: "Squared",
						value: "butt",
					},
				]}
			/>

			<H2RInput
				type="range"
				label="Thickness"
				colour="dark"
				// min={0}
				// min={1}
				// step={0.1}
				value={thicknessOptions.findIndex((e, i) => {
					if (e.value === baseTheme?.[graphic]?.thickness) return i;
				})}
				labelValue={findThemeLabel(
					thicknessOptions,
					baseTheme?.[graphic]?.thickness
				)}
				options={thicknessOptions}
				max={thicknessOptions.length - 1}
				onChange={(change) => {
					cuesApi.updateTheme(
						projectId,
						themeId,
						graphic,
						"thickness",
						thicknessOptions[change].value
					);
				}}
			/>
		</>
	);
};

const ChecklistOptions = ({ themeId, baseTheme, graphic }) => {
	let { projectId } = useParams();
	return (
		<>
			<H2RSelect
				label="List style"
				colour="dark"
				selected={baseTheme[graphic]?.list_style || "none"}
				onChange={(change) => {
					cuesApi.updateThemeOverride(
						projectId,
						themeId,
						"checklist",
						"list_style",
						change
					);
				}}
				options={[
					{
						label: "None",
						value: "none",
					},
					{
						label: "Bullet list",
						value: "disc",
					},
					{
						label: "Numbered list",
						value: "decimal",
					},
				]}
			/>
			<H2RInput
				key={`${baseTheme.name}_checklist_width`}
				type="range"
				label="Width"
				colour="dark"
				value={widthAndHeightScreenOptions.findIndex((e, i) => {
					if (e.value === baseTheme[graphic]?.width) return i;
				})}
				labelValue={
					findThemeLabel(
						widthAndHeightScreenOptions,
						baseTheme[graphic]?.width
					) || "Auto"
				}
				options={widthAndHeightScreenOptions}
				max={widthAndHeightScreenOptions.length - 1}
				onChange={(change) => {
					cuesApi.updateTheme(
						projectId,
						themeId,
						"checklist",
						"width",
						widthAndHeightScreenOptions[change].value
					);
				}}
			/>
			<H2RInput
				key={`${baseTheme.name}_checklist_height`}
				type="range"
				label="Height"
				colour="dark"
				value={widthAndHeightScreenOptions.findIndex((e, i) => {
					if (e.value === baseTheme[graphic]?.height) return i;
				})}
				labelValue={
					findThemeLabel(
						widthAndHeightScreenOptions,
						baseTheme[graphic]?.height
					) || "Auto"
				}
				options={widthAndHeightScreenOptions}
				max={widthAndHeightScreenOptions.length - 1}
				onChange={(change) => {
					cuesApi.updateTheme(
						projectId,
						themeId,
						"checklist",
						"height",
						widthAndHeightScreenOptions[change].value
					);
				}}
			/>
		</>
	);
};
